import type { AIUnifiedEventPayload } from '@atlaskit/editor-common/analytics';
import { ACTION } from '@atlaskit/editor-common/analytics';

export type DelayedActionPayload = {
	action: 'delayedAction';
	actionSubject: 'aiDelayedResult';
	actionSubjectId: 'editorPluginAI';
	attributes: {
		aiExperienceName?: string;
		aiGroupId: string | undefined;
		delayedAtMs: number;
		traceIds?: string[];
	};
	eventType: 'track';
};

// This is a special event not exactly the unified event so we will record these separately
export const createDelayedTrackActionedPayload = (
	payload: AIUnifiedEventPayload,
	delayedAt: number,
): DelayedActionPayload => {
	return {
		action: 'delayedAction',
		actionSubject: 'aiDelayedResult',
		actionSubjectId: 'editorPluginAI',
		eventType: 'track',
		attributes: {
			aiExperienceName: payload.attributes?.aiExperienceName,
			aiGroupId: payload.action === ACTION.ACTIONED ? payload.attributes?.aiGroupId : undefined,
			traceIds: payload.attributes?.traceIds,
			delayedAtMs: delayedAt,
		},
	};
};
